import dialogMixin from "@/mixin/dialogMixin";
import listMixin from "@/mixin/listMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";

export default {
  mixins: [resDisposeMixin, dialogMixin, listMixin],
  watch: {
    params: {
      deep: true,
      handler: function (newValue) {
        if (
          newValue.chargeTemplateInfoList &&
          newValue.chargeTemplateInfoList.length > 1
        ) {
          for (let i = 1; i < newValue.chargeTemplateInfoList.length; i++) {
            this.params.chargeTemplateInfoList[i].startPower =
              newValue.chargeTemplateInfoList[i - 1].endPower + 1;
            this.$refs["params"].validate();
          }
        }

        if (
          newValue.serviceFeeByPowerList &&
          newValue.serviceFeeByPowerList.length > 1
        ) {
          for (let i = 1; i < newValue.serviceFeeByPowerList.length; i++) {
            this.params.serviceFeeByPowerList[i].miniPower =
              newValue.serviceFeeByPowerList[i - 1].maxPower + 1;
            this.$refs["params"].validate();
          }
        }
      },
    },
    params2: {
      deep: true,
      handler: function (newValue) {
        if (newValue.monthlyInfoList && newValue.monthlyInfoList.length > 1) {
          for (let i = 1; i < newValue.monthlyInfoList.length; i++) {
            // this.params2.monthlyInfoList[i].startPower =
            //   newValue.monthlyInfoList[i - 1].endPower;
            this.$refs["params2"].validate();
          }
        }
      },
    },
    params3: {
      deep: true,
      handler: function (newValue) {
        if (newValue.monthlyInfoList && newValue.monthlyInfoList.length > 1) {
          for (let i = 1; i < newValue.monthlyInfoList.length; i++) {
            this.$refs["params3"].validate();
          }
        }
      },
    },
  },
  computed: {
    listStart() {
      return (index, key = "params") => {
        let len = (
          this[key].chargeTemplateInfoList || this[key].monthlyInfoList
        ).length;
        return index === len - 1;
      };
    },
    listEnd() {
      return (index, key = "params") => {
        let len = (
          this[key].chargeTemplateInfoList || this[key].monthlyInfoList
        ).length;
        return index !== 0 && index === len - 1;
      };
    },
    listOnlyOne() {
      return (index, key = "params") => {
        let len = (
          this[key].chargeTemplateInfoList || this[key].monthlyInfoList
        ).length;
        return index === 0 && len === 1;
      };
    },
  },
  data() {
    function endPower(rule, value, callback) {
      let index = rule.field.replace(/[^0-9]/gi, "");
      let start = this.params.chargeTemplateInfoList[index].startPower;
      if (value <= start) {
        callback(new Error("结束瓦数小于开始瓦数"));
      } else {
        callback();
      }
    }

    function maxPower(rule, value, callback) {
      let index = rule.field.replace(/[^0-9]/gi, "");
      let start = this.params.serviceFeeByPowerList[index].miniPower;
      console.log(value, start, 9090);
      if (value <= start) {
        callback(new Error("结束瓦数小于开始瓦数"));
      } else {
        callback();
      }
    }

    const startingFare = (rule, value, callback) => {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      if (this.checked === true) {
        if (!reg.test(value)) {
          callback(new Error("请输入数字"));
        } else if (value <= 0) {
          callback(new Error("金额必须大于0"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const interval = (rule, value, callback) => {
      if (typeof value === "number" && !isNaN(value)) {
        if (value < 1) {
          callback(new Error("时间必须大于1"));
        } else {
          callback();
        }
      }
    };
    const moneyNumber = (rule, value, callback) => {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      // if (this.params.chargeType === "2") {

      // } else {
      //   callback();
      // }
      if (value === "") {
        callback(new Error("请输入金额"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入数字"));
      } else if (value < 0) {
        callback(new Error("金额不能小于0"));
      } else {
        callback();
      }
    };
    function endPower2(rule, value, callback) {
      //   let index = rule.field.replace(/[^0-9]/gi, "");
      //   let start = this.params2.monthlyInfoList[index].startPower;
      if (value <= 0) {
        callback(new Error("最大功率必须大于0"));
      } else {
        callback();
      }
    }
    const moneyNumber2 = (rule, value, callback) => {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      if (value === "") {
        callback(new Error("请输入金额"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入数字"));
      } else if (value <= 0) {
        callback(new Error("金额必须大于0"));
      } else {
        callback();
      }
    };
    const freeChargeNum2 = (rule, value, callback) => {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      if (value === "") {
        callback(new Error("请输入时长"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入数字"));
      } else if (value <= 0) {
        callback(new Error("时长必须大于0"));
      } else {
        callback();
      }
    };
    const moneyNumber3 = (rule, value, callback) => {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      if (value === "") {
        callback(new Error("请输入停车收费金额"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入数字"));
      } else if (value <= 0) {
        callback(new Error("金额必须大于0"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        money: [{ required: true, validator: moneyNumber }],
        startingFare: [{ validator: startingFare }],
        powerFare: [{ required: true, validator: moneyNumber }],
        interval: [
          { required: true, message: "请输入分钟数" },
          { type: "number", message: "请输入整数" },
          { validator: interval },
        ],
        timeLenMinute: [
          { required: true, message: "请输入分钟数" },
          { type: "number", message: "请输入整数" },
          { validator: interval },
        ],
        endPower: [
          { type: "number", message: "请输入整数" },
          { required: true, message: "请输入结束功率" },
          { required: true, validator: endPower.bind(this) },
        ],
        serviceFeeByPowerListMaxPower: [
          { type: "number", message: "请输入整数" },
          { required: true, message: "请输入结束功率" },
          { required: true, validator: maxPower.bind(this) },
        ],
      },
      rules2: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        money: [{ required: true, validator: moneyNumber2 }],
        freeChargeNum: [{ required: true, validator: freeChargeNum2 }],
        startingFare: [{ validator: startingFare }],
        powerFare: [{ required: true, validator: moneyNumber2 }],
        interval: [
          { required: true, message: "请输入分钟数" },
          { type: "number", message: "请输入整数" },
          { validator: interval },
        ],
        endPower: [
          { type: "number", message: "请输入整数" },
          { required: true, message: "请输入最大功率" },
          { required: true, validator: endPower2.bind(this) },
        ],
      },
      rules3: {
        name: [
          { required: true, message: "请输入车辆类型名称", trigger: "blur" },
        ],
        money: [{ required: true, validator: moneyNumber3, trigger: "blur" }],
        // chargeMonthlyInfoId: [
        //   { required: true, validator: chargeMonthlyInfoId3 },
        // ],
      },
    };
  },
  methods: {
    changeChargeType() {
      this.$refs.params.clearValidate();
    },
    resetItem(key = "params") {
      if (key == "params") {
        this.params.chargeTemplateInfoList = [
          {
            money: undefined,
            freeDayNum: undefined,
            freeChargeNum: undefined,
            startPower: 0,
            endPower: undefined,
          },
        ];
      } else if (key == "params2") {
        this.params2.monthlyInfoList = [
          {
            money: undefined,
            freeDayNum: undefined,
            freeChargeNum: undefined,
            startPower: 0,
            endPower: undefined,
          },
        ];
      } else if (key == "params3") {
        this.params3.monthlyInfoList = [
          {
            name: undefined,
            money: undefined,
            chargeMonthlyInfoId: undefined,
          },
        ];
      }
      this.$nextTick(() => {
        this.$refs[key].clearValidate();
      });
    },
    addItem(item, key = "params") {
      this.$refs[key].validate((valid) => {
        if (valid) {
          if (key == "params") {
            this.params.chargeTemplateInfoList.push({
              money: undefined,
              freeDayNum: undefined,
              freeChargeNum: undefined,
              startPower: item.endPower,
              endPower: undefined,
            });
          } else if (key == "params2") {
            this.params2.monthlyInfoList.push({
              money: undefined,
              freeDayNum: undefined,
              freeChargeNum: undefined,
              startPower: 0,
              endPower: undefined,
            });
          } else if (key == "params3") {
            this.params3.monthlyInfoList.push({
              name: undefined,
              money: undefined,
              chargeMonthlyInfoId: undefined,
            });
          }
        }
      });
    },
  },
};
